import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { TeacherProvider } from 'src/app/providers/teacher/teacher.provider';
import { Teacher } from 'src/app/models/teacher';
import { AccessCodePopoverComponent } from '../../access-code-popover/access-code-popover.component';
import { Common } from '../../../lib/common';
import { PageHeaderCommands, Dismissable } from '../page-header.commands';
import { Command } from 'protractor';
import { TeacherStore } from 'src/app/stores/teacher.store';
import { Subject, map, takeUntil } from 'rxjs';

@Component({
  selector: 'app-users-menu',
  templateUrl: './users-menu.component.html',
  styleUrls: ['./users-menu.component.scss']
})
export class UsersMenuComponent implements OnInit, Dismissable {

  popover: PopoverController;
  teacher: Teacher;
  ngUnsubscribeTeacher = new Subject();
  
  constructor(navParams: NavParams,
    private teacherStore: TeacherStore,
    public commands: PageHeaderCommands,
    private teacherProvider: TeacherProvider) {
    this.popover = navParams.get('popoverController');

    this.teacher = this.teacherProvider.teacher;
    this.teacherStore.state$
        .pipe(takeUntil(this.ngUnsubscribeTeacher))
        .subscribe(() => {
          this.teacher = this.teacherProvider.teacher;
        });
  }

  ngOnInit() {
  }
  
  ngOnDestroy(){
    this.ngUnsubscribeTeacher.next(true);
    this.ngUnsubscribeTeacher.complete();
  }

  dismiss() {
    this.popover.dismiss()
  }

}
